import { init } from "@marko/runtime-tags/dom";
import "./about.marko";
import "../../src/routes/+layout.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/about-section/index.marko";
import "../../src/tags/app-header/index.marko";
import "../../src/tags/app-footer/index.marko";
import "../../src/tags/about-section/index.marko";
export default () => init();